
































import { defineComponent, computed, ref, PropType, toRefs } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { logger } from '@tt4b/ttam-utils';
import singleVideoEmptyPng from '@tt4b/ttam-assets/src/images/creative/single-video-empty.png';
import SelectButtons from './buttons.vue';
const name = 'ttam-material-select';

export default defineComponent({
  name,

  components: {
    SelectButtons,
  },

  props: {
    isNative: { type: Boolean, default: false },
    isSingleImage: { type: Boolean, default: false },
    isSelected: { type: Boolean, default: false },
    isHoverButtons: { type: Boolean, default: false },
    isSupportChangeCover: { type: Boolean, default: false },
    isSupportUsePullVideo: { type: Boolean, default: false },
    isSupportTTBAPushVideo: { type: Boolean, default: false },
    isPushVideoButtonDisabled: { type: Boolean, default: false },
    isSupportTTBCPushVideo: { type: Boolean, default: false },
    isHasMaterial: { type: Boolean, default: false },
    isSingleVideo: { type: Boolean, default: true },
    size: { type: String, default: 'normal' },
    isTiktokPostBtnDisabled: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const materialInfo = computed(() => ({
      imageUrl: singleVideoEmptyPng,
      name: i18n.t('module_creative_video_add_signle_video'),
    }));
    const onClick = type => {
      logger.info(`${name} click type`, type);
      emit('select', type);
    };
    return {
      name,
      materialInfo,
      onClick,
    };
  },
});
